import { CtaButton, Spinner } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components';

export const StyledButton = styled(CtaButton)`
  cursor: pointer;
  display: flex;

  &:not(:first-child) {
    margin-left: ${rem('12px')};
  }
`;

export const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.m}) {
    grid-template-columns: 1fr;
    gap: 0px;
  }
`;

export const StyledSpinner = styled(Spinner)`
  margin-right: ${rem('5px')};
`;

export const StyleButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.s}) {
    justify-content: space-between;
  }
`;

export const StyledTextWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding-top: ${rem('20px')};
`;

export const StyledTextLabel = styled.div`
  font-weight: 400;
  font-size: ${rem('16px')};
  color: ${({ theme }) => theme.colors.cross.grayson};
`;

export const StyledText = styled.div`
  font-weight: 400;
  font-size: ${rem('16px')};
  color: ${({ theme }) => theme.colors.cross.black};
`;
